<template>
  <Portlet
    :title="$t('menu.quickSupportCommands')"
    icon="code"
    class="quickSupportCommands"
  >
    <template slot="buttons">
      <button 
        class="btn btn-sm btn-primary float-right mt-2 mb-2" 
        @click="showSidebarAdd"
      >
        <font-awesome-icon
          class="mr-1"
          icon="plus"
        />
        <span>
          {{ $t('add') }}
        </span>
      </button>
      <div class="clearfix" />
    </template>
    <QuickSupportCommandsList
      ref="quickSupportCommandsList"
      @reloadAuditLogs="reloadAuditLogs"
    /> 
    <DatabaseAuditLogList
      ref="databaseAuditLogList"
      :is-quick-commands="true"
      @reload="reloadQuickSupportCommandsList"
    />
  </Portlet>
</template>

<script>
export default {
    name: 'QuickSupportCommands',
    components: {
        QuickSupportCommandsList: () => import('@/components/Device/QuickSupportCommandsList.vue'),
        DatabaseAuditLogList: () => import('@/components/DatabaseAuditLogs/DatabaseAuditLogsList.vue')
    },
    metaInfo () {
        return {
            title: this.$t('menu.quickSupportCommands')
        }
    },
    methods: {
      showSidebarAdd () {
        this.$refs.quickSupportCommandsList.showSidebarAdd();
      },
      reloadAuditLogs () {
        this.$refs.databaseAuditLogList.reloadAuditLogs();
      },
      reloadQuickSupportCommandsList () {
        this.$refs.quickSupportCommandsList.getQuickSupportCommands();
      }
    }
}
</script> 